<script setup name="TvbHomePage">
import { inject, onMounted, ref, computed, onServerPrefetch } from 'vue'
import { useSeoMeta, useHead } from '@unhead/vue'
// import TvbHomeMpm from './components/Mpm/index.vue'
// import TvbHomeEpg from './components/Epg/index.vue'
import TvbHomeNotification from './components/Notification/index.vue'
import TvbHomeColumns from './components/Columns/index.vue'
import { pageview } from './../../utils/gtm'
import 'swiper/css'

const seo = inject('seo')
// const size = inject('size')
const setAdParams = inject('setAdParams')

setAdParams({})
onMounted(() => {
  pageview({
    page_title: 'home',
    screen_class: 'home',
    screenID: 'S001',
    eventCategory: 'home',
    eventLabel: 'home',
    eventID: 'S001',
    screenLabel: location.origin
  })
  setSeo()
})
const setSeo = () => {
  const canonical = import.meta.env.SSR ? import.meta.env.VITE_HOST_URL : location.origin
  head.value = {
    link: [
      {
        rel: 'canonical',
        key: 'canonical',
        href: canonical
      },
      {
        rel: 'alternate',
        hreflang: 'x-default',
        key: 'alternate-x-default',
        href: canonical
      },
      {
        rel: 'alternate',
        hreflang: 'zh-hk',
        key: 'alternate-zh-hk',
        href: canonical
      }
    ],
    script: [
      {
        id: 'home-ld-json',
        type: 'application/ld+json',
        innerHTML: JSON.stringify([
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'TVB 無綫集團',
            alternateName: ['TVB', 'TVB Limited', 'www.tvb.com', '無綫集團'],
            url: canonical,
            logo: 'https://img.tvb.com/homepage/TVB_homepage.png',
            description:
              'TVB Limited (TVB) is one of the world’s largest commercial Chinese programme producers. Headquartered in Hong Kong, TVB is one of the few broadcasters in the world that operates a vertically integrated business model encompassing content creation, broadcasting and distribution.',
            sameAs: [
              'https://www.facebook.com/tvbcom',
              'https://www.instagram.com/tvbcomhk/',
              'https://www.youtube.com/user/tvb',
              'https://twitter.com/tvbcom',
              'https://weibo.com/p/1002061955190431/home',
              'https://i.youku.com/i/UNTkxNTk4NTYw?spm=a2hzp.8253869.0.0',
              'https://www.ixigua.com/home/3645610205917294/',
              'https://www.toutiao.com/c/user/token/MS4wLjABAAAAcMyBR6t9hhMSxwZNw5PlE8ioyyrKI3FDWVG150mSej9WcwnOkiq2LQ9qjpkVNhs-/'
            ],
            address: {
              '@type': 'PostalAddress',
              streetAddress:
                'TVB, 77 Chun Choi Street, Tseung Kwan O Industrial Estate, New Territories, Hong Kong',
              addressLocality: 'Hong Kong',
              addressCountry: 'CHINA'
            },
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'tvbpr@tvb.com.hk',
              telephone: '+852-2335-9123'
            }
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'TVB 無綫集團',
            alternateName: ['TVB', 'TVB Limited', 'www.tvb.com', '無綫集團'],
            url: canonical,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: canonical + '/search?keyword={search_term_string}'
              },
              'query-input': 'required name=search_term_string'
            }
          }
        ])
      }
    ]
  }
  patch(head.value)
}
const head = ref({})
const { patch } = useHead(head)
onServerPrefetch(setSeo)

const SeoMeta = computed(() => {
  const { og_image_url, og_image_alt_txt, seo_title, meta_description } = seo?.value || {}
  return {
    title: `${seo_title || ''}`,
    description: `${meta_description || ''}`,
    ogUrl: location.origin,
    ogTitle: `${seo_title || ''}`,
    ogImage: `${og_image_url || ''}`,
    ogImageAlt: `${og_image_alt_txt || ''}`,
    ogDescription: meta_description || '',
    twitterTitle: `${seo_title || ''}`,
    twitterImage: `${og_image_url || ''}`,
    twitterDescription: `${meta_description || ''}`,
    twitterUrl: location.origin
  }
})
useSeoMeta(SeoMeta)
</script>

<template>
  <main class="tvb-home-page">
    <tvb-home-columns />
    <tvb-ads :position="6" :ad-type="'to'" />
    <tvb-home-notification />
  </main>
</template>

<style lang="scss" scoped>
.tvb-home-page {
  &.s,
  &.xs {
    padding: 0 0 32px 0 !important;
  }
}
</style>
